import { render, staticRenderFns } from "./ModalSaldoRitiroCliente.vue?vue&type=template&id=32fd55a8&scoped=true&"
import script from "./ModalSaldoRitiroCliente.vue?vue&type=script&lang=js&"
export * from "./ModalSaldoRitiroCliente.vue?vue&type=script&lang=js&"
import style0 from "./ModalSaldoRitiroCliente.vue?vue&type=style&index=0&id=32fd55a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fd55a8",
  null
  
)

export default component.exports